<div class="snapshot">
  <div class="d-flex align-items-start">
    <div class="snapshot-history">
      <div class="header d-flex align-items-center">
        <p class="title">Tool History</p>
        <div class="toolbar row">
          <div class="col-6">
            <div class="form-group position-relative">
              <input
                type="text"
                class="form-control"
                placeholder="Search"
                [(ngModel)]="search"
                (keyup.enter)="handleSearch()" />
              <button type="button" (click)="handleSearch()">
                <i class="fal fa-search"></i>
              </button>
            </div>
          </div>
          <div class="col-3">
            <div *ngIf="types" class="form-group">
              <select class="form-control" (change)="filterByType($event)">
                <option value="" selected>Select Type</option>
                <option *ngFor="let type of types" [value]="type.value">{{ type.label }}</option>
              </select>
            </div>
          </div>
          <div class="col-3">
            <div *ngIf="snapshotDates" class="form-group">
              <select class="form-control" (change)="filterByDate($event)">
                <option value="" selected>Select Date</option>
                <option *ngFor="let value of snapshotDates.data" [value]="value">{{ value }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="snapshot" class="content d-flex align-items-start">
        <div class="col-6 all">
          <div class="group" *ngFor="let key of Object.keys(snapshot.data)">
            <p class="title">{{ key }}</p>
            <div class="items" *ngIf="snapshot.data[key]">
              <div class="item" *ngFor="let row of snapshot.data[key]">
                <!-- duplicate -->
                <ng-container *ngIf="row.type === 'duplicate'">
                  <span class="icon duplicate"><img src="/assets/images/icon/copy.svg" /></span>
                  <p>
                    {{ row.summary }}
                    <span *ngIf="hasUser(row)"
                      >by <span class="user">{{ getUserName(row) }}</span></span
                    >
                  </p>
                  <p>{{ getDate(row) }}</p>

                  <!-- duplicate -->
                  <ng-container *ngIf="getDuplicate(row)">
                    <div class="details">
                      <div class="detail">
                        <a href="/tools/edit/{{ getDuplicate(row).id }}" target="_blank">
                          <span>{{ getDuplicate(row).toolId }}</span>
                          <i class="fas fa-external-link-alt"></i>
                        </a>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>

                <!-- add -->
                <ng-container *ngIf="row.type === 'add'">
                  <span class="icon add"><img src="/assets/images/icon/add.svg" /></span>
                  <p>
                    {{ row.summary }}
                    <span *ngIf="hasUser(row)"
                      >by <span class="user">{{ getUserName(row) }}</span></span
                    >
                  </p>
                  <p>{{ getDate(row) }}</p>
                  <p *ngIf="getToolAlertMessage(row)">{{ getToolAlertMessage(row) }}</p>
                </ng-container>

                <!-- edit -->
                <ng-container *ngIf="row.type === 'edit'">
                  <span class="icon edit"><img src="/assets/images/icon/edit.svg" /></span>
                  <p>
                    {{ row.summary }} by <span class="user">{{ getUserName(row) }}</span>
                  </p>
                  <p>{{ getDate(row) }}</p>

                  <!-- images added -->
                  <ng-container *ngIf="hasImages(row)">
                    <div class="images">
                      <div class="image" *ngFor="let image of getImages(row)">
                        <a
                          href="{{ image.url }}"
                          target="_blank"
                          [ngStyle]="{ 'background-image': 'url(' + image.url + ')' }"></a>
                      </div>
                      <div class="remaining-images" *ngIf="getRemainingImages(row) > 0">
                        <span>+{{ getRemainingImages(row) }}</span>
                      </div>
                    </div>
                  </ng-container>

                  <!-- documents added -->
                  <ng-container *ngIf="hasDocuments(row)">
                    <div class="details">
                      <div class="detail" *ngFor="let document of getDocuments(row)">
                        <a href="{{ document.url }}" target="_blank">
                          <span>{{ document.name }}</span>
                          <i class="fas fa-external-link-alt"></i>
                        </a>
                      </div>
                    </div>
                  </ng-container>

                  <!-- image removed -->
                  <ng-container *ngIf="getImage(row)">
                    <div class="details">
                      <div class="detail">{{ getImage(row).name }}</div>
                    </div>
                  </ng-container>

                  <!-- changes -->
                  <ng-container *ngIf="hasChanges(row)">
                    <div class="details">
                      <div class="detail" *ngFor="let change of getChanges(row)">
                        <span
                          ><span class="field">{{ change.field }}</span> changed
                          <span *ngIf="getChangedFromLabel(change)">from </span>
                          <span *ngIf="getChangedFromLabel(change)" class="old">{{ getChangedFromLabel(change) }}</span>
                          to <span class="new">{{ getChangedToLabel(change) }}</span></span
                        >
                      </div>
                    </div>
                  </ng-container>
                </ng-container>

                <!-- assignment -->
                <ng-container *ngIf="row.type === 'assignment'">
                  <span class="icon assignment"><img src="/assets/images/icon/corner-down-right.svg" /></span>
                  <p>
                    {{ row.summary }} by <span class="user">{{ getUserName(row) }}</span>
                  </p>
                  <p>
                    <span>{{ getDate(row) }}</span>
                    <span class="ml-3" *ngIf="getDaysHad(row) >= 0">Days had: {{ getDaysHad(row) }}</span>
                  </p>
                  <div class="detail">
                    <span *ngIf="!getAssignedFrom(row)"
                      >Assigned to: <span class="new">{{ getAssignedTo(row) }}</span></span
                    >
                    <p>Transfer ID: {{ row.id }}</p>
                    <p *ngIf="getBatchId(row)">Transfer Batch ID: {{ getBatchId(row) }}</p>
                    <p>Assigned Date: {{ getAssignedDate(row) }}</p>
                  </div>
                  <p>Transfer Notes: {{ getNotes(row) }}</p>

                  <!-- assigned from and assigned to -->
                  <ng-container *ngIf="getAssignedFrom(row) && getAssignedTo(row)">
                    <div class="details">
                      <div class="detail">
                        <span
                          >Changed from: <span class="old">{{ getAssignedFrom(row) }}</span> to
                          <span class="new">{{ getAssignedTo(row) }}</span></span
                        >
                      </div>
                    </div>
                  </ng-container>
                </ng-container>

                <!-- inventory -->
                <ng-container *ngIf="row.type === 'inventory'">
                  <span class="icon assignment"><img src="/assets/images/icon/corner-down-right.svg" /></span>
                  <p>
                    {{ row.summary }} by <span class="user">{{ getUserName(row) }}</span>
                  </p>
                  <p>
                    <span>{{ getDate(row) }}</span>
                    <span class="ml-3" *ngIf="getDaysHad(row) >= 0">Days had: {{ getDaysHad(row) }}</span>
                  </p>
                  <div class="detail">
                    <span *ngIf="!getAssignedFrom(row)"
                      ><span class="new">{{ getAssignedTo(row) }}</span></span
                    >
                    <p>Inventory Batch Number: {{ getInventoryBatchNumber(row) }}</p>
                    <p>Inventoried Date: {{ getInventoriedDate(row) }}</p>
                  </div>
                  <p>Inventory Notes: {{ getInventoriedNotes(row) }}</p>

                  <!-- assigned from and assigned to -->
                  <ng-container *ngIf="getAssignedFrom(row) && getAssignedTo(row)">
                    <div class="details">
                      <div class="detail">
                        <span
                          >Changed from: <span class="old">{{ getAssignedFrom(row) }}</span> to
                          <span class="new">{{ getAssignedTo(row) }}</span></span
                        >
                      </div>
                    </div>
                  </ng-container>
                </ng-container>

              </div>
            </div>
          </div>

          <p *ngIf="!Object.keys(snapshot.data).length">No results</p>

          <a
            class="link"
            href="#"
            *ngIf="snapshot.pagination.currentPage < snapshot.pagination.totalPages"
            (click)="fetchNext(snapshot.pagination.nextPage, $event)"
            >Load More</a
          >
        </div>
      </div>
    </div>
  </div>
</div>
